import React, { useEffect, useState } from "react";
import { ACTION_REQUESTED, TEARDOWN } from "MODULES/RepairOrders/constants";
import api from "APP_ROOT/api";
import { LINE_ITEMS, UPDATED_AT } from "APP_ROOT/constants";
import Application from "MODULES/RepairOrders/components/Detail/Teardowns/Application";

const Subcomponents = ({ repairOrder }) => {
  const tearDown = repairOrder
    .get(LINE_ITEMS)
    .find(l => l.get(ACTION_REQUESTED) === TEARDOWN);
  if (!tearDown) return null;

  const lineItem = tearDown.toJS();
  const [records, setRecords] = useState([]);

  useEffect(
    () => {
      api.parts.applications.list(lineItem.part_id, 1, 100).then(resp => {
        setRecords(
          resp.data.results.filter(l => l.type === "LowerAssemblyApplication")
        );
        return function cleanup() {};
      });
    },
    [repairOrder.get(UPDATED_AT)]
  );

  if (records.length === 0) return null;

  return (
    <table>
      <thead>
        <tr>
          <h2>Known Subcomponents</h2>
        </tr>
      </thead>
      <tbody>
        {records.map(r => <Application application={r} key={r.id} />)}
      </tbody>
    </table>
  );
};

export default Subcomponents;



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/Teardowns/Subcomponents.jsx